import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';
import * as moment from 'moment';
import { PageViewTrackingEvent, TrackingInput } from '@app/@core/models/tracking-event.model';
import { InstrumentationService } from '@app/@core/services/instrumentation/instrumentation.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  public ableToFulfill: boolean = false;
  public isAbleToFulfill: boolean = false;
  public filter: string = '';
  public isMOVCorrect: boolean = true;
  public MOVOrderObject: any = {};
  public PriceOrderObject: any = {};
  public showCriticalOrder: boolean = false;
  public sortTATBy : any = '';
  public criticalOrdersNavigatedViaHomePage : boolean = false;

  constructor(
    private http: HttpClient,
    private instrumentationService: InstrumentationService
  ) { }

  getOrderList(requestBody) {
    let pType = requestBody.purchaseType ? requestBody.purchaseType : 'null';
    let showCriticalOrders = requestBody.showCriticalOrders ? requestBody.showCriticalOrders : false;
    let sortTATParam = requestBody.sortTATBy ? requestBody.sortTATBy : 'updatedDate:DESC';
    return this.http.get(
      environment.with_auth_url +
      '/seller/api/v1/order?pageNo=' +
      requestBody.pageNumber +
      '&pageSize=20&sellerOrderStatus=' +
      requestBody.status + '&purchaseType=' +  pType +
      '&showCriticalOrders=' + showCriticalOrders +
      '&sortBy=' + sortTATParam
    );
  }

  getOrderCount() {
    return this.http.get(
      environment.with_auth_url +
      '/seller/api/v1/order?pageNo=1&pageSize=1&sortBy=updatedDate:DESC&sellerOrderStatus=PAYMENT_PENDING'
    );
  }

  bulkAcceptOrder(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/bulk-acceptance',
      requestBody
    );
  }

  getPickUpaddress() {
    return this.http.get(
      environment.with_auth_url + '/seller/api/v1/seller/address?addressType=OPERATIONAL'
    );
  }

  bulkFulfillment(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/bulk-acceptance',
      requestBody
    );
  }

  // bulkDownload(requestBody) {
  //   return this.http.post(
  //     environment.with_auth_url + '/seller/api/v1/bulk-download',
  //     requestBody,
  //     { responseType: 'blob' }
  //   );
  // }

  bulkShippingLabelDownload(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/bulk-download/shipping-label',
      requestBody,
      { responseType: 'blob' }
    );
  }

  bulkInvoiceDownload(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/bulk-download/invoice',
      requestBody,
      { responseType: 'blob' }
    );
  }

  checkServiceability(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/bulk-serviceability-check',
      requestBody
    );
  }

  setCriticalOrderShowFlag(showCriticalOrderFlag){
    this.showCriticalOrder = showCriticalOrderFlag;
  }

  getCriticalOrderShowFlag() {
    return this.showCriticalOrder;
  }

  setTATSort(sortBy){
    this.sortTATBy = sortBy;
  }

  getTATSort(){
    return this.sortTATBy;
  }

  isOrderCancelledByScheduler(order){
    let date_diff_expiry : any;
    let tatParameter = order?.graceTAT ? order?.graceTAT : order?.handlingTAT;
    const fromExpiredTATDate = moment(tatParameter);
    const toDate = moment();
    date_diff_expiry =  moment.duration(moment(fromExpiredTATDate).diff(moment(toDate)));
    if(date_diff_expiry._milliseconds <= 0){
        return true;
    }
    else {
      return false;
    }
  }

  setCriticalOrdersNavFromHome(homeFlag){
    this.criticalOrdersNavigatedViaHomePage = homeFlag;
  }

  getCriticalOrdersNavFromHome(){
    return this.criticalOrdersNavigatedViaHomePage;
  }

  setFulfilmentFlag(isFulfill) {
    this.ableToFulfill = isFulfill;
  }

  getFulfilmentFlag() {
    return this.ableToFulfill;
  }

  cancelOrder(orderId, status, reason) {
    if (status === 'OPEN' || status === 'CHAT') {
      return this.http.put(
        environment.with_auth_url + '/seller/api/v1/order-cancel/' + orderId + '/' + reason,
        {}
      );
    } else {
      return this.http.post(
        environment.with_auth_url + '/seller/api/v1/order-cancel',
        {
          cancelReason: reason,
          mobileNumber: sessionStorage.getItem('companyNumber'),
          orderId: orderId,
        }
      );
    }
  }

  checkInvoiceSettings() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/seller');
  }

  checkDuplicateInvoiceNumber(invoiceId, invoiceNumber) {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/seller/checkDuplicateInvoiceNumber/' + invoiceId + '?invoiceNumber=' + invoiceNumber);
  }

  getAllCancelReason() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/order-cancel/getAllReasons');
  }

  setFilterFromHomeTab(filter) {
    this.filter = filter;
  }

  getFilter() {
    return this.filter;
  }

  getMinimumOrdervalue() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/order/edit-config');
  }

  setMOVObject(object) {
    this.MOVOrderObject = object;
    console.log(this.MOVOrderObject);
  }

  setMinimumOrderValueFlag(mov, orderId) {
    this.MOVOrderObject[orderId] = mov;
    console.log(this.MOVOrderObject)
  }

  setPriceObject(object) {
    this.PriceOrderObject = object;
  }

  setPriceErrorFlag(flag, orderId) {
    this.PriceOrderObject[orderId] = flag;
  }

  getMinimumOrderValueFlag() {
    console.log(!Object.values(this.MOVOrderObject).includes(false),
      !Object.values(this.PriceOrderObject).includes(false))
    return !Object.values(this.MOVOrderObject).includes(false) &&
      !Object.values(this.PriceOrderObject).includes(false);  //[true, true]
  }

  setPriceFulfilmentFlag(isFulfill) {
    this.isAbleToFulfill = isFulfill;
  }

  getPriceFulfilmentFlag() {
    return this.isAbleToFulfill;
  }

  eInvoicePreference() {
    const url = environment.with_auth_url + '/seller/api/v2/e-invoice/preference';
    return this.http.get(url);
  }

  eInvoicePreferencePost(reqObj) {
    const url = environment.with_auth_url + '/seller/api/v2/e-invoice/preference';
    return this.http.post(url, reqObj);
  }

  eInvoicePreferencePut(reqObj) {
    const url = environment.with_auth_url + '/seller/api/v2/e-invoice/preference';
    return this.http.put(url, reqObj);
  }

  getFromKYCMediaStore(key) {
    const url = environment.with_auth_url + '/media-store/kyc/' + key;
    return this.http.get(url, { responseType: 'blob' });
  }

  creditNoteDownload(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/bulk-download/credit-note',
      requestBody,
      { responseType: 'blob' }
    );
  }

  searchOrderWithOrderId(orderId) {
    const url =  `${environment.with_auth_url}/seller/api/v1/order/search/${orderId}`;
    return this.http.get(url);
  }

  fetchEwayBill(orderId) {
    const url =  `${environment.with_auth_url}/seller/api/v1/eway/${orderId}`;
    return this.http.get(url);
  }

  uploadEwayBill(requestBody, orderId, ewayBillNumber) {
    const url = `${environment.with_auth_url}/seller/api/v1/eway?orderId=${orderId}&EWayBillNo=${ewayBillNumber}`;
    return this.http.post(
      url,
      requestBody
    );
  }

  downloadEwayBill(fileKey) {
    const uniqueRequestId = Math.random()*1000;
    const url =  `${environment.with_auth_url}/seller/api/v1/eway/file/${fileKey}?x-request-id=${uniqueRequestId}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  confirmFullTruckLoad(req){
    const url = `${environment.with_auth_url}/seller/api/v1/ftl-operations/isFTL?orderId=${req.orderId}&state=${req.state}`;
   return this.http.post(url,{});

  }

  splitOrder(req) {
    const url = `${environment.with_auth_url}/seller/api/v1/ftl-operations/split-order`;
    return this.http.post(url,req);
  }
  logPageViewEvent(pageName): void{
    const trackingInput: TrackingInput<PageViewTrackingEvent> = {
        eventLabel: 'Page Viewed',
        eventName: 'PAGE_VIEWED',
        eventSource: 'Menu Bar',
        pageName: pageName,
        viewedAt: Date.now()
    };
    this.instrumentationService.logEvent<PageViewTrackingEvent>(
        trackingInput
    );
  }
}
